import { EventEmitter } from '@comeon/utility';

export const CONFIG = {
	customerDomain: window.location.origin,
	enableHighAccuracy: true,
	maxAge: 0,
	orgID: 'wh2hgf17',
	periodicLookupDelay: 60000, // 1 min
	profilingDomain: 'dpcontent.locationsmart.net',
	scriptURL: 'https://api.locationsmart.net/v4/html5/?version=v2',
	timeout: 30000,
	watch: true,
	watchDuration: 30
};

export const eventStream = EventEmitter('locationsmart');
export const EVENTS = {
	profile_done: 'profile_done',
	init: 'initiliaze',
	update: 'update',
	stop: 'stop'
};

export enum States {
	start = 0,
	initialized = 1,
	init = 2,
	pending = 3,
	resolving = 4,
	processing = 5,
	complete = 6,
	stop = 7
}
